import { View, Text, TouchableOpacity, Modal, Image, Platform } from "react-native";
import React, { useRef, useState, useEffect } from "react";
import Ionicons from "@expo/vector-icons/Ionicons";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { s } from "react-native-size-matters";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import { StackActions, useNavigation } from "@react-navigation/native";
import { AppScreens } from "../../Utility/AppScreens";
import { toast } from "react-toastify";
import OTPTextView from "react-native-otp-textinput";
import * as Clipboard from 'expo-clipboard';

const VerificationModal = (props, route) => {
  const {
    showModal = false,
    setShowModal,
    pinVerifySuccess = () => { },
  } = props;

  const onCloseClick = () => {
    setShowModal(false);
  };
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [otpInput, setOtpInput] = useState("");
  const otpRef = useRef<any>(null);

  useEffect(() => {
    const handlePaste = async (event: any) => {
      try {
        let text;
        // Use navigator.clipboard for web, expo-clipboard for mobile
        if (typeof navigator !== "undefined" && navigator.clipboard) {
          text = await navigator.clipboard.readText();
        } else {
          text = await Clipboard.getStringAsync();
        }

        if (text && /^\d{5}$/.test(text)) {
          setOtpInput(text);
          if (otpRef.current) {
            otpRef.current.setValue(text);
          }
        }
      } catch (error) {
        console.log('Paste error:', error);
      }
    };

    // Add paste event listener for web
    if (typeof window !== "undefined") {
      window.addEventListener("paste", handlePaste);
      return () => {
        window.removeEventListener("paste", handlePaste);
      };
    };
  }, []);

  const pasteFromClipboard = async () => {
    try {
      const text = await Clipboard.getStringAsync();
      if (text && /^\d{5}$/.test(text)) {
        setOtpInput(text);
        if (otpRef.current) {
          otpRef.current.setValue(text);
        }
      } else if (text && /^\d+$/.test(text.substring(0, 5))) {
        // If user copied more than 5 digits, take first 5
        const otpCode = text.substring(0, 5);
        setOtpInput(otpCode);
        if (otpRef.current) {
          otpRef.current.setValue(otpCode);
        }
      }
    } catch (error) {
      console.log('Paste from clipboard error:', error);
    }
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View
        style={[
          styles.container,
          { justifyContent: "center", alignItems: "center" },
        ]}
      >
        <View style={styles.mainView}>
          <View
            style={{
              flexDirection: "row",
              paddingTop: 20,
              justifyContent: "center",
            }}
          >
            <Text style={[AppFontStyle.BOLD_ANYBODY_32, { flex: 1 }]}>
              Verification
            </Text>
          </View>

          <View
            style={{
              height: 2,
              marginTop: 20,
              backgroundColor: AppColors.appGrayColor_1C1C1C,
              width: "100%",
            }}
          />

          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_16,
              { paddingTop: 23, paddingVertical: 15, color: AppColors.white },
            ]}
          >
            We have sent 5 digit code to your email, enter the code for withdraw
            amount
          </Text>

          <View style={{ height: 90, marginVertical: 40 }}>
            {/* OTP View */}
            <OTPTextView
              ref={otpRef}
              handleTextChange={setOtpInput}
              offTintColor={AppColors.appBlackColor_1e1e1e}
              tintColor={AppColors.white}
              // containerStyle={{
              //     height: 60,
              // }}
              textInputStyle={styles.roundedTextInput}
              inputCount={5}
              inputCellLength={1}
              keyboardType="numeric"
            />
          </View>

          {/* Paste from Clipboard Button - Mobile Only */}
          {Platform.OS !== 'web' && (
            <TouchableOpacity
              onPress={pasteFromClipboard}
              style={{
                marginBottom: 17,
                alignSelf: 'center',
              }}
            >
              <Text
                style={[
                  {
                    color: AppColors.appViolentColor_6D08C3,
                    textDecorationLine: 'underline',
                    fontSize: 14,
                  },
                ]}
              >
                Paste from clipboard
              </Text>
            </TouchableOpacity>
          )}

          {/* Bottom Buttons */}
          <View style={styles.bottomButtonBGView}>
            {/* Cancel */}
            <TouchableOpacity
              style={{
                height: 40,
                paddingHorizontal: 15,
                borderColor: AppColors.appViolentColor_6D08C3,
                borderWidth: 1,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                flex: 1,
              }}
              onPress={() => {
                onCloseClick();
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  {
                    color: AppColors.appViolentColor_6D08C3,
                    textAlign: "center",
                  },
                ]}
              >
                Cancel
              </Text>
            </TouchableOpacity>

            {/* Continue */}
            <TouchableOpacity
              style={{
                height: 40,
                paddingHorizontal: 15,
                backgroundColor: AppColors.appViolentColor_6D08C3,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                flex: 1,
              }}
              onPress={() => {
                // if (otpInput.length < 5) {
                //     toast.error("Please enter 5 digit code", { type: "error", });
                //     return;
                // }
                pinVerifySuccess();
                onCloseClick();
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  { color: AppColors.white, textAlign: "center" },
                ]}
              >
                Continue
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default VerificationModal;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
    },
    mainView: {
      width: 450,
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 40,
      paddingVertical: 20,
      margin: 30,
      alignSelf: "center",
      borderRadius: 12,
    },
    roundedTextInput: {
      borderRadius: 10,
      borderWidth: 1,
      borderBottomWidth: 1,
      alignContent: "center",
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      fontSize: 16,
      color: AppColors.white,
      shadowColor: AppColors.bgBlueColor_1B0D38,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.2,
      shadowRadius: 2,
      elevation: 2,
      width: 60,
      height: 60,
    },
    bottomButtonBGView: {
      height: 50,
      justifyContent: "flex-end",
      flexDirection: "row",
      gap: 15,
      marginVertical: 20,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "60%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
        borderWidth: 1,
        borderColor: AppColors.grayColor_565656,
      },
      roundedTextInput: {
        borderRadius: 10,
        borderWidth: 1,
        borderBottomWidth: 1,
        alignContent: "center",
        backgroundColor: AppColors.appBlueColor_3A5175,
        fontSize: 16,
        color: AppColors.white,
        shadowColor: AppColors.bgBlueColor_1B0D38,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.2,
        shadowRadius: 2,
        elevation: 2,
        width: 60,
        height: 60,
      },
      bottomButtonBGView: {
        height: 50,
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "60%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
        borderWidth: 1,
        borderColor: AppColors.grayColor_565656,
      },
      roundedTextInput: {
        borderRadius: 10,
        borderWidth: 1,
        borderBottomWidth: 1,
        alignContent: "center",
        backgroundColor: AppColors.appBlueColor_3A5175,
        fontSize: 16,
        color: AppColors.white,
        shadowColor: AppColors.bgBlueColor_1B0D38,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.2,
        shadowRadius: 2,
        elevation: 2,
        width: 60,
        height: 60,
      },
      bottomButtonBGView: {
        height: 50,
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "70%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
        borderWidth: 1,
        borderColor: AppColors.grayColor_565656,
      },
      roundedTextInput: {
        borderRadius: 10,
        borderWidth: 1,
        borderBottomWidth: 1,
        alignContent: "center",
        backgroundColor: AppColors.appBlueColor_3A5175,
        fontSize: 16,
        color: AppColors.white,
        shadowColor: AppColors.bgBlueColor_1B0D38,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.2,
        shadowRadius: 2,
        elevation: 2,
        width: 60,
        height: 60,
      },
      bottomButtonBGView: {
        height: 50,
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 16,
        margin: 16,
        alignSelf: "center",
        borderRadius: 12,
        borderWidth: 1,
        borderColor: AppColors.grayColor_565656,
      },
      roundedTextInput: {
        borderRadius: 10,
        borderWidth: 1,
        borderBottomWidth: 1,
        alignContent: "center",
        backgroundColor: AppColors.appBlueColor_3A5175,
        fontSize: 16,
        color: AppColors.white,
        shadowColor: AppColors.bgBlueColor_1B0D38,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.2,
        shadowRadius: 2,
        elevation: 2,
        width: 60,
        height: 60,
      },
      bottomButtonBGView: {
        height: 50,
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
    },
  }
);
